export default __webpack_public_path__ + "static/media/hht1_storybook_08.cd2edc24.png";